module.exports = __webpack_public_path__ + "static/media/AB_shadow_horisontal_mobile.1db7ba03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_shadow_horisontal_mobile.png
// module id = 33
// module chunks = 0